import { DettaglioCertificazioneDtoFromJSON, DettaglioCertificazioneEmailDtoFromJSON } from "@desio/api";
import { createReducer } from "@reduxjs/toolkit";
import { getAvvioCertificazione, getCertificazioneEmail, getDettaglioCertificazione, getLogCedcri, inviaEmail, resetResultAvvioCertificazione, resetResultInvioMail } from "./actions";
import { DettaglioCertificazioneReducerType } from "./types";

const initialState: DettaglioCertificazioneReducerType = {
  dettaglioCertificazione: DettaglioCertificazioneDtoFromJSON({}),
  resultAvvioCertificazione: undefined,
  dettaglioCertificazioneEmail: DettaglioCertificazioneEmailDtoFromJSON({}),
  dettaglioCertificazioneCliente: undefined,
  resultInvioEmail: undefined,
  logCedacri: undefined

};

export const dettaglioCertificazioneReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getDettaglioCertificazione.pending, (state) => {

      state.dettaglioCertificazione = initialState.dettaglioCertificazione;

    })
    .addCase(getDettaglioCertificazione.fulfilled, (state, action) => {
      if (action.payload) {
        state.dettaglioCertificazione = action.payload;
      }
    })
    .addCase(getCertificazioneEmail.pending, (state) => {

      state.dettaglioCertificazioneEmail = initialState.dettaglioCertificazioneEmail;
    })
    .addCase(getCertificazioneEmail.fulfilled, (state, action) => {
      if (action.payload) {
        state.dettaglioCertificazioneEmail = action.payload;
      }
    })
    .addCase(getAvvioCertificazione.pending, (state) => {
      state.resultAvvioCertificazione = initialState.resultAvvioCertificazione;
    })
    .addCase(getAvvioCertificazione.fulfilled, (state, action) => {
      state.resultAvvioCertificazione = action.payload;
    })
    .addCase(inviaEmail.pending, (state) => {
      state.resultInvioEmail = initialState.resultInvioEmail;
    })
    .addCase(inviaEmail.fulfilled, (state, action) => {
      state.resultInvioEmail = action.payload;
    })
    .addCase(resetResultInvioMail, (state) => {
      state.resultInvioEmail = initialState.resultInvioEmail;
    })
    .addCase(getLogCedcri.pending, (state) => {
      state.logCedacri = initialState.logCedacri;
    })
    .addCase(getLogCedcri.fulfilled, (state, action) => {
      state.logCedacri = action.payload;
    })
    .addCase(resetResultAvvioCertificazione, (state) => {
      state.resultAvvioCertificazione = initialState.resultAvvioCertificazione;
    });


});


